"use client";

import { selectLoginStatus, useAppSelector } from "@repo/web-store";
import Link from "next/link";
import { EasyAccessLinkProps } from "../types";
import { handleEasyAccess } from "../utils";

const EasyAccessLink = ({
  redirectionUrl,
  label,
  sectionTitle,
}: EasyAccessLinkProps) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  return (
    <Link
      href={redirectionUrl}
      className="flex w-full items-center justify-between border-b border-gray-200 py-[12px] pl-[16px] pr-[12px] text-[#0f1111] last:border-b-0"
      onClick={() => {
        handleEasyAccess(loginStatus, sectionTitle || "Easy Access", label);
      }}
    >
      <div className="">
        <h2 className="text-[14px] text-[#0f1111]">{label}</h2>
      </div>
      <div>
        <i className="!font-semibold icomoon text-sm before:content-['\e911']"></i>
      </div>
    </Link>
  );
};

export default EasyAccessLink;
